import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";

const SalesManReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [salesManData, setSalesManData] = useState([]);
  const[custSalesMan, setCustSalesMan] = useState(null)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const[cust, setCust] = useState(null)
  const [docName, setDocName] = useState('')
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().startOf('month').format(),
    toDate : moment().format()
  })
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
 
  function getSalesMan(){
    axios.get('/v1/SalesMan')
    .then(res=>setSalesManData(res.data))
    .catch(err=>{console.log(err);dispatch(
      setSnackbar(true, "error", err.response.data.error)
    );})
    }
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "name",
    headerName: "Salesman Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "OutletName",
    headerName: "Outlet Name",
    minWidth:150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_bills",
    headerName: "Total Bills",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
 
  {
    field: "return",
    headerName: "Return",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "avg_bills",
    headerName: "Avg Bills",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
   
  },
  {
    field: "sales",
    headerName: "Sales",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },

]

const rows = _.map(data,(val,idx)=>({
  id: idx+1,
  sno: idx+1,
  name : val.sales_man_name,
  sales : parseFloat(val.sales).toFixed(2),
  total_bills:val.total_bills,
  return:val.return,
  avg_bills:parseFloat(val.avg_bills).toFixed(2),
  OutletName:val.fullname === "" ? "-" : val.fullname
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  setTotalFlag(true)
  let total = 0;
  data.forEach(val => {
      total += parseFloat(val.sales);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }

function handleSalesmanReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
    outletid:cust !== null ? cust.id : 0,
    salesman_id:custSalesMan !== null ? custSalesMan.id : 0
  }
  console.log(postData)
  axios.post(`/v1/reports/salesman/getone` ,postData)
  .then(res=>{
    if(res.data.length > 0){
      setData(res.data)
      setPageCount(res.data.length)
    }else{
    setData([])
    setPageCount(0)
    }
  })
  .catch(err=>{
    if(err.response.data.errors[0].message){
      const error = err.response.data.errors[0];
      if(error.code === "NOT_FOUND"){
       setData([])
       setPageCount(0);
      dispatch(setSnackbar(true, "error", error.message));
      }else {
        dispatch(setSnackbar(true, "error", error.message));
      }
    }else {
      dispatch(setSnackbar(true, "error", "An unexpected error occurred."));
    }
  })
}

useEffect(() => {
  getSupplierData();
  getSalesMan()
}, []);
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesmanReport()
    }
  },[rowsPerPage, page, dateLimit,cust,custSalesMan])
  return (
    <Fragment>
      <Helmet>Salesman Reports</Helmet>
      <Typography variant="h6">Salesman Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
      <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 ,fullname : "All"} , ...supplier]}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname } 
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
        <Autocomplete
            size="small"
            options={salesManData}
            onChange={(e,value)=>setCustSalesMan(value)}
            getOptionLabel={(option) =>
              `${option.sales_man_name} - ${option.sales_man_code}`
            }
            renderInput={(params) => <TextField {...params} label="Select Salesman" />}
  />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      {/* {rows.length > 0 ? (
      <CustomTable props={props} />
    ) : (
      <Typography variant="body1" align="center" style={{ marginTop: '20px' }}>
        No data available
      </Typography>
    )} */}
    </Fragment>
  );
};

export default memo(SalesManReport);
